import { IDatePickerDictonary } from '@/dictionaries/components/datePicker/types';
import { cn } from '@/lib/utils';
import { Trigger } from '@radix-ui/react-dialog';
import ArrowRightIcon from '../Icons/ArrowRight';

type Props = {
  confirmedDates: { start: Date | null; end: Date | null };
  dict: IDatePickerDictonary;
  className?: string;
  isOneDate?: boolean;
  atVillagePage?: boolean;
  id?: string;
  labelClassName?: string;
};

export default function DatePickerTrigger({
  confirmedDates,
  dict,
  isOneDate = false,
  className,
  atVillagePage,
  id,
  labelClassName,
}: Props) {
  return (
    <div className={cn('w-full flex flex-col', className)}>
      {isOneDate ? (
        <div className="w-full flex text-gray-700 text-sm">
          <label className={cn('leading-[1.8]', labelClassName)}>
            {dict.date}
          </label>
        </div>
      ) : (
        <div className="w-full flex text-gray-700 text-sm">
          <div className="w-1/2">
            <label className={cn('leading-[1.8]', labelClassName)}>
              {dict.checkIn}
            </label>
          </div>
          <div className="w-1/2">
            <label className={cn('leading-[1.8] ml-2', labelClassName)}>
              {dict.checkOut}
            </label>
          </div>
        </div>
      )}
      <Trigger asChild>
        {isOneDate ? (
          <button
            aria-label="Open datepicker"
            className="outline-none w-full h-[2.5625rem] min-h-[44px] px-2 py-4 text-gray-700 bg-gray-100 border border-gray-200 flex">
            <div className="w-1/2 h-full flex justify-end items-center">
              {confirmedDates?.start ? (
                <span className="text-gray-850 mr-auto">
                  {confirmedDates.start.toLocaleDateString()}
                </span>
              ) : (
                dict.placeholders.checkIn
              )}
            </div>
          </button>
        ) : (
          <button
            aria-label="Open datepicker"
            className="outline-none w-full h-[2.5625rem] min-h-[44px] py-2 px-4 text-gray-700 bg-gray-100 border border-gray-200 flex justify-between">
            <div
              className={cn(
                'w-[41.66667%] flex-[0_0_auto] h-full flex justify-end items-center',
                {
                  'w-1/2': atVillagePage,
                },
              )}>
              <span className="text-gray-850 mr-auto whitespace-nowrap">
                {confirmedDates?.start
                  ? confirmedDates.start.toLocaleDateString()
                  : dict.placeholders.checkIn}
              </span>
              {atVillagePage && (
                <ArrowRightIcon className="fill-current mr-2 desktop:mr-[.2rem] w-7 h-7 text-gray-500" />
              )}
            </div>
            {!atVillagePage && (
              <ArrowRightIcon className="fill-current mr-2 w-7 h-7 text-gray-500" />
            )}
            <div
              className={cn(
                'w-[41.66667%] flex-[0_0_auto] h-full flex items-center justify-start',
                {
                  'w-1/2': atVillagePage,
                },
              )}>
              <span className={cn('text-gray-850', { 'pl-2': atVillagePage })}>
                {confirmedDates?.end
                  ? confirmedDates.end.toLocaleDateString()
                  : dict.placeholders.checkOut}
              </span>
            </div>
          </button>
        )}
      </Trigger>
    </div>
  );
}
